/** Semiconductor process-tool palette — navy frame, warm gray body, subtle cyan glass. */
export const EQUIPMENT_2D_COLORS = {
  outline: '#152536',
  frame: '#1B2838',
  frameDeep: '#0F1824',
  frameHighlight: '#2A3D52',
  body: '#1E2D3F',
  bodyShade: '#152536',
  panel: '#E8E4DC',
  panelWarm: '#DDD6CB',
  panelRecess: '#C9C2B6',
  seam: '#9AA3AD',
  screenBezel: '#243447',
  screen: '#3A5568',
  screenGlow: '#6EC4D8',
  ledReady: '#4ADE80',
  ledBusy: '#FBBF24',
  ledFault: '#64748B',
  vent: '#1A2533',
  ventLine: '#64748B',
  glass: 'rgba(120, 196, 214, 0.45)',
  glassStroke: '#5EB4C5',
  glassSheen: 'rgba(255, 255, 255, 0.35)',
  loadDeck: '#2A3644',
  loadPad: '#B8BFC6',
  loadPadInner: '#9CA8B3',
  loadRim: '#4A90A4',
  base: '#1B2838',
  baseDark: '#0E1620',
  /** Legacy alias (toolbox tray tint). */
  pedestal: '#2A3644',
  slot: '#9AA4AC',
  alignShade: '#C6CDD4',
  alignLine: '#4A90A4',
  foup: '#00CCFF',
  foupLid: '#7DE8FF',
  foupStroke: '#0369A1',
  foupProcessed: '#00CCFF',
  foupProcessedStroke: '#0369A1',
  selection: '#5EB4C5',
  hover: '#8FD4E3',
} as const;

export const EQUIPMENT_2D_SIMPLE_ZOOM = 0.35;
